import {NgModule} from '@angular/core';
import {NavComponent} from './nav.component';
import {AppRoutingModule} from '../../app-routing.module';
import {CommonModule} from '@angular/common';
import {NavService} from './nav.service';
import {AuthenticationService} from '../services/authentication.service';
import {NavNodeComponent} from './nav-node.component';

@NgModule({
    imports: [
        CommonModule,
        AppRoutingModule
    ],
    declarations: [
        NavComponent,
        NavNodeComponent
    ],
    providers: [
        NavService,
        AuthenticationService
    ],
    exports: [
        NavComponent
    ]
})

export class NavModule {
}



// WEBPACK FOOTER //
// ./src/app/_shared/nav/nav.module.ts